import React from 'react';
import { LABEL_FONT_SIZE } from '../..';
import { LABEL_FONT_FAMILY } from '../../constants';
export const BaseLabel = ({ y, children, color: fill, fontSize = LABEL_FONT_SIZE, transform }) => (React.createElement("text", { x: "50%", y: y || '50%', dominantBaseline: "middle", textAnchor: "middle", fill: fill, fontFamily: LABEL_FONT_FAMILY, fontSize: `${fontSize}px`, transform: transform, style: {
        userSelect: 'none',
    } }, children));
//# sourceMappingURL=base-label.js.map